import { useContext } from 'react'
import { NotificationContext } from '@/components/ui'

export const useNotification = () => {
  const context = useContext(NotificationContext)

  if (context === undefined) {
    throw new Error('useNotification hook must be used inside NotificationProvider')
  }

  const message = {
    selectState: 'Please, select state',
    teacherCreatedSuccessfully: 'The teacher was created successfully',
    participantCreatedSuccessfully: 'The participant was created successfully',
    participantUpdatedSuccessfully: 'The participant was updated successfully',
    organizationChangedSuccessfully: 'The organization has changed successfully',
    provideUuid: 'Please, provide uuid',
    provideToken: 'Please, provide token',
    selectOneParticipant: 'Please, select at least one participant',
    invitationSent: (name: string) => `Invitation sent to ${name}`,
    tooLargeCropFile: 'Cropping result is too large',
    infoWasSaved: 'The information was successfully saved',
    phoneIsBusy: 'Mobile is busy',
    emailIsBusy: 'Email is busy',
    linkCopied: 'Invitation link successfully copied',
    cantSendInvite: ({ name, address }: { name: string; address: string }) =>
      `Oops! You've recently invited ${name || address}`,
    sentDashboardLink: 'We just sent you a text to share your link!',
  }

  return {
    ...context,
    message,
  }
}
